import type {FooterProps} from '../../components/Footer';
import type {SiteSettingsFragment} from '../query';

export const footerPropsFromSiteSettingsFragment = (
	siteSettings: SiteSettingsFragment,
): FooterProps => {
	const {email, phoneNumber, orgName, address} = siteSettings;

	return {
		email: email,
		phoneNumber: phoneNumber,
		orgName: orgName,
		address: address,
	};
};
